import { StoreService } from '../core/store.service';
import { SessionItem, eItem } from '.';
import { Subscription } from 'rxjs';

export class BaseStore {

  protected result: Subscription;

  constructor(
    protected store: StoreService,
  ) { }

  public evalLabel(targetPage: string, key: string): string {

    return '';
  }

  public customLabel(targetPage: string, key: string): string {
    return this.store.getCustomLabel(targetPage, key);
  }
  public trad(key: string): string {
    return this.store.getTrad(key);
  }

  public openPage(pageCode: string): void {
    this.store.openPage(pageCode);
  }

  protected getSession(itemType: eItem): SessionItem | null {
    return this.store.GetDataSession(itemType);
  }

  protected removeSession(itemType: eItem): void {
    this.store.RemoveSession(itemType);
  }
}
